// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"278":"polyfills-dom","329":"polyfills-core-js"}[chunkId] || chunkId) + "." + {"278":"d3b4160a","329":"a1aee00f","917":"543416cf"}[chunkId] + ".chunk.js";
};